// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"TopicHeader_imageWrapper__EG07d","image":"TopicHeader_image__9r6Pf","text":"TopicHeader_text__S0Ozv","fade_in":"TopicHeader_fade_in__ZS7BZ"};